import React from "react";
import SummarizeIcon from '@mui/icons-material/Summarize';

function AccountsIcon() {
  return (
    <SummarizeIcon sx={{ fill: 'white', width: 27, height: 27 }} />
  );
}

export default AccountsIcon;
